import {Directive, forwardRef, Input} from '@angular/core';
import {NG_VALIDATORS, AbstractControl, Validator} from '@angular/forms';
import {TYPE_VALIDATORS} from './type.validators';

const PROVIDER_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => TypeValidator),
    multi: true
};

/**
 * Directive, which adds validators by type attribute
 */
@Directive({
    selector: '[type]',
    providers: [PROVIDER_VALIDATOR]
})
export class TypeValidator implements Validator {

    @Input('type') validatorType: string;

    validate(control: AbstractControl) {
        if (TYPE_VALIDATORS[this.validatorType]) {
            return TYPE_VALIDATORS[this.validatorType](control);
        } else {
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/validator.directive.ts